import { buildInteractiveResult, Result, SearchEngine } from '@coveo/headless';
import React, { FunctionComponent, useEffect, PropsWithChildren } from 'react';
import { headlessEngine } from '../engine';

interface LinkProps extends PropsWithChildren {
  result: Result;
  target?: string;
  link: string;
  className: string;
  dataLayer?: string;
  download?: boolean;
  ariaLabel?: string;
}

// Filters out dangerous URIs that can create XSS attacks such as `javascript:`.
function filterProtocol(uri: string) {
  const isAbsolute = /^(https?|ftp|file|mailto|tel):/i.test(uri);
  const isRelative = /^\//.test(uri);

  return isAbsolute || isRelative ? uri : '';
}

export const ResultLink: FunctionComponent<LinkProps> = props => {
  const interactiveResult = buildInteractiveResult(
    headlessEngine as SearchEngine,
    {
      options: { result: props.result }
    }
  );

  useEffect(() => () => interactiveResult.cancelPendingSelect(), []);

  return (
    <a
      href={filterProtocol(props.link)}
      onClick={() => interactiveResult.select()}
      onContextMenu={() => interactiveResult.select()}
      onMouseDown={() => interactiveResult.select()}
      onMouseUp={() => interactiveResult.select()}
      onTouchStart={() => interactiveResult.beginDelayedSelect()}
      onTouchEnd={() => interactiveResult.cancelPendingSelect()}
      data-layer={props.dataLayer}
      className={props.className}
      target={props.target ? props.target : '_blank'}
      {...(props.download ? { download: props.download } : {})}
      aria-label={props.ariaLabel ? props.ariaLabel : undefined}
    >
      {props.children}
    </a>
  );
};
